export default __webpack_public_path__ + "img/throughput.c6a4b00.svg";